import {
  isNonNullable
} from "./chunk-K54LRIUM.mjs";

// lib/components/form/common/form-state.ts
var getFormClassName = ({ isTouched, error }) => {
  if (isTouched !== true) {
    return "";
  }
  if (isNonNullable(error)) {
    return "is-danger is-error";
  }
  return "is-success";
};
var getFieldStateStyle = (fieldState) => {
  return fieldState.invalid ? "is-danger" : fieldState.isDirty ? "is-success" : "";
};

export {
  getFormClassName,
  getFieldStateStyle
};
